import { createRouter, createWebHistory, Router } from 'vue-router'
import useSettingStore from '@/store/setting'

const mainIndex = () => import('@/views/index.vue')
const notFound = () => import('@/views/common/notFound.vue')
const videoEnhancer = () => import('@/views/videoEnhancer/viewWrapper.vue')
const videoEnhancerIndex = () => import('@/views/videoEnhancer/index.vue')
const videoEnhancerEditor = () => import('@/views/videoEnhancer/editor.vue')
const vocalRemover = () => import('@/views/vocalRemover/viewWrapper.vue')
const vocalRemoverIndex = () => import('@/views/vocalRemover/index.vue')
const vocalRemoverEditor = () => import('@/views/vocalRemover/editor.vue')
const videoGenerator = () => import('@/views/videoGenerator/viewWrapper.vue')
const videoGeneratorIndex = () => import('@/views/videoGenerator/index.vue')
const videoGeneratorEditor = () => import('@/views/videoGenerator/editor.vue')

const routes = [
  {
    path: '/',
    redirect: 'enhance-video-online',
    component: mainIndex,
    children: [
      {
        path: 'enhance-video-online',
        component: videoEnhancer,
        children: [
          {
            path: '',
            name: 'videoEnhancerIndex',
            component: videoEnhancerIndex,
            meta: {
              title: 'HitPaw Online AI Video Enhancer - 100% Safe',
            },
          },
          {
            path: 'editor',
            name: 'videoEnhancerEditor',
            component: videoEnhancerEditor,
            meta: {
              title: 'Video Enhancer | Editing',
            },
          },
        ],
      },
      {
        path: 'vocal-remover',
        component: vocalRemover,
        children: [
          {
            path: '',
            name: 'vocalRemoverIndex',
            component: vocalRemoverIndex,
            meta: {
              title: 'HitPaw Online AI Vocal Remover',
            },
          },
          {
            path: 'editor',
            name: 'vocalRemoverEditor',
            component: vocalRemoverEditor,
            meta: {
              title: 'HitPaw Online AI Vocal Remover',
            },
          },
        ],
      },
      {
        path: 'video-generator',
        component: videoGenerator,
        children: [
          {
            path: '',
            name: 'videoGeneratorIndex',
            component: videoGeneratorIndex,
            meta: {
              title: 'HitPaw Online AI Video Generator',
            },
          },
          {
            path: 'editor',
            name: 'videoGeneratorEditor',
            component: videoGeneratorEditor,
            meta: {
              title: 'HitPaw Online AI Video Generator',
            },
          },
        ],
      },
    ],
  },
  {
    name: '404',
    path: '/:pathMatch(.*)*',
    component: notFound,
  },
]

const router: Router = createRouter({
  history: createWebHistory('/video/'),
  routes
})
router.beforeEach( async (to, from, next) => {
  let title = to.meta.title as string
  document.title = title || 'HitPaw Online'
  useSettingStore().setIsJump('before')
  next()
})
router.afterEach( async (to, from) => {
  setTimeout(() => {
    useSettingStore().setIsJump('after')
  },200)
})
export default router